// component-grid-slider.js (version légère, lazy)
(() => {
  const SWIPER_SRC = "{{ 'swiper-bundle.min.js' | asset_url }}";

  function loadScriptOnce(src) {
    return new Promise((resolve, reject) => {
      if (window.Swiper) return resolve();
      if (document.querySelector(`script[data-swiper-src="${src}"]`)) {
        document.addEventListener('swiper:ready', () => resolve(), { once: true });
        return;
      }
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.async = true;
      s.setAttribute('data-swiper-src', src);
      s.onload = () => {
        document.dispatchEvent(new CustomEvent('swiper:ready'));
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  class GridSlider extends HTMLElement {
    connectedCallback() {
      // Si déjà initialisé
      if (this._inited) return;
      this._inited = true;

      // Lazy init : uniquement quand visible
      const initWhenVisible = () => {
        const start = () => this._ensureAndInit();
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries.some(e => e.isIntersecting)) { start(); io.disconnect(); }
          }, { rootMargin: '400px' });
          io.observe(this);
        } else {
          // Fallback
          window.addEventListener('load', start, { once: true });
        }
      };

      initWhenVisible();
    }

    async _ensureAndInit() {
      try {
        await loadScriptOnce(SWIPER_SRC);
        this._initSwiper();
      } catch (e) {
        console.error('Swiper load failed', e);
      }
    }

    _initSwiper() {
      // Récup props depuis data-*
      const wrap = this.closest('[data-grid-slider-wrapper]');
      const scrollbar = wrap?.querySelector('.swiper-scrollbar');
      const nextEl = wrap?.querySelector('.swiper-button--next');
      const prevEl = wrap?.querySelector('.swiper-button--prev');

      // Calcule slidesPerView (simplifié / non bloquant)
      const d = this.dataset;
      const productsToShow = parseInt(d.productLimit || '4', 10);
      const spvDesktop = (parseFloat(d.slidesPerViewDesktop || '4') || 4) + 0.5;
      const spvTablet  = 3.5;
      let spvMobile  = parseFloat(d.slidesPerViewMobile || '2') || 2;
      spvMobile = spvMobile === 1 ? spvMobile + 0.08 : spvMobile - 1 + 0.5;

      // Init Swiper (bundle UMD — modules déjà inclus)
      this.swiperInstance = new window.Swiper(this, {
        spaceBetween: 15,
        slidesPerView: spvMobile,
        loop: false,
        // Désactive tout ce qui n’est pas indispensable pour limiter le travail JS
        a11y: false,
        watchOverflow: true,
        navigation: (nextEl && prevEl) ? { nextEl, prevEl } : undefined,
        scrollbar: scrollbar ? { el: scrollbar, draggable: true } : undefined,
        breakpoints: {
          768:  { spaceBetween: 30, slidesPerView: 'auto' /* ou spvTablet */ },
          1024: { spaceBetween: 30, slidesPerView: 'auto' /* ou spvDesktop */ }
        },
        on: {
          init: () => wrap && wrap.classList.add('swiper-initialized')
        }
      });
    }
  }

  if (!customElements.get('grid-slider')) {
    customElements.define('grid-slider', GridSlider);
  }
})();